import React from 'react';
import styles from './CancelButton.module.css';
import { useNavigate } from 'react-router-dom';


const CancelButton = ({ label, url, onClick, className = '', containerClassName = '', useContainer = true, disabled = false }) => {
    const navigate = useNavigate();
    const text = label === 'Back' ? 'Back' : 'Cancel';

    const goBack = () => {
        if (typeof onClick === 'function') {
            onClick();
            return;
        }

        switch (label) {
            case 'Back':
                window.history.back();
                return;
            case 'Cancel':
                window.location.reload();
                return;
            case 'CancelUserEdit':
                window.location.reload();
                navigate(url, { state: { isEdit: false } });
                return;
            default:
                window.location.reload();
        }
    };

    const button = (
        <button
            type="button"
            onClick={goBack}
            disabled={disabled}
            className={`${styles.cancelButton} ${className}`.trim()}
        >
            {text}
        </button>
    );

    if (!useContainer) {
        return button;
    }

    return (
        <div className={`${styles.buttonContainer} ${containerClassName}`.trim()}>
            {button}
        </div>

    );
};

export default CancelButton;
